/**
 * Logs detailed information about the token and user role
 * 
 * @param userRole The user's role ID
 */
export const getAccessToken = () => localStorage.getItem("access_token");

export function logTokenAndRoleInfo(userRole: number | null = null) {
  const token = localStorage.getItem("access_token");
  
  console.group("🔐 Token and Role Information");
  console.log(`Has token: ${!!token}`);
  console.log(`User role: ${userRole !== null ? userRole : "Not assigned"}`);
  
  if (token) {
    try {
      // Parse the JWT token (without verification)
      const parts = token.split('.');
      if (parts.length === 3 && parts[1]) {
        const payload = JSON.parse(atob(parts[1]));
        console.log("Token payload:", payload);
      } else {
        console.log("Invalid token format (not a valid JWT)");
      }
    } catch (error) {
      console.error("Error parsing token:", error);
    }
  }
  
  console.groupEnd();
}
